export default {"src":"/_next/static/media/banzai_icon_rgb_banzai-blue.d285cf22.svg","height":203,"width":203,"blurWidth":0,"blurHeight":0};